import {DEFAULT_TAX_ACCOUNTANT_NAME, TaxAccountantNameModel} from "@/shared/model";
import * as z from "zod";
import {DetailModel} from "./DetailModel";

const schema = z.object({
	taxAccountantName: TaxAccountantNameModel.model,
	incomeDate: z.string().nullable(),
	details: z.array(DetailModel.model)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantVisitHistoryModel = {schema, model};
export type ITaxAccountantVisitHistoryModel = z.infer<typeof TaxAccountantVisitHistoryModel.model>;
export const DEFAULT_TAX_ACCOUNT_VISIT_HISTORY: ITaxAccountantVisitHistoryModel = {
	taxAccountantName: DEFAULT_TAX_ACCOUNTANT_NAME,
	incomeDate: "",
	details: []
};
